// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const tva: CountryValidator<"MC"> = createValidator(
  "mc.tva",
  122,
);

export default tva;
export const compact = tva.compact;
export const format = tva.format;
export const validate = tva.validate;
export const generate = (): string =>
  tva.generate?.() ??
  (() => {
    throw new Error(
      "Validator mc.tva cannot generate values",
    );
  })();
